import type { HTTPConfiguration } from "kubb";
import type React from "react";
import * as Yup from "yup";
import NewTextFormComponent from "../../../components/Forms/NewTextFormComponent";
import { yupRequiredString } from "../../../components/Forms/yupValidators";

export const HTTPExportConfigurationSchema = Yup.object().shape({
  host: Yup.string()
    .required("Must be a valid HTTPS URL")
    .matches(/^https:\/\/.*/i, "Must be a valid HTTPS URL")
    .url("Must be a valid HTTPS URL"),
  username: yupRequiredString,
  password: yupRequiredString,
  port: Yup.number()
    .min(0, "Must be a valid TCP port 0-65,535")
    .max(65535, "Must be a valid TCP port 0-65,535"),
  path: Yup.string().optional(),
  params: Yup.string().optional(),
});

export const HTTPExportInitialValues: HTTPConfiguration = {
  host: "",
  port: 443,
  username: "",
  password: "",
  path: undefined,
  auth_type: "BASIC_AUTH",
  params: undefined,
};

export default function HTTPExportConfigurationForm({
  namespace,
  disabled = false,
}: {
  namespace: string;
  disabled?: boolean;
}): React.ReactElement {
  const withNamespace = (fieldName: string): string => {
    return namespace ? `${namespace}.${fieldName}` : fieldName;
  };

  return (
    <>
      <h4>HTTP Configuration</h4>
      <NewTextFormComponent
        fieldName={withNamespace("host")}
        label={{ label: "URL" }}
        disabled={disabled}
      />
      <NewTextFormComponent
        fieldName={withNamespace("port")}
        label={{ label: "Port" }}
        disabled={true}
      />
      <NewTextFormComponent
        fieldName={withNamespace("username")}
        label={{ label: "Username" }}
        disabled={disabled}
      />
      <NewTextFormComponent
        fieldName={withNamespace("password")}
        label={{ label: "Password" }}
        disabled={disabled}
      />
      <NewTextFormComponent
        fieldName={withNamespace("path")}
        label={{ label: "Remote path (optional)" }}
        disabled={disabled}
      />
      <NewTextFormComponent
        fieldName={withNamespace("params")}
        label={{ label: "Optional post params (optional, as key map)" }}
        disabled={disabled}
      />
    </>
  );
}
